import { publicInstance, authorizedInstance } from "../config/axios"

export const submitCustomerFeedback = async (feedbackData) => {
  const response = await publicInstance.post(
    "/customer-feedback/",
    feedbackData
  )
  return response.data
}

export const getCustomerFeedbacks = async (filters) => {
  const params = new URLSearchParams()

  // Add all filter parameters to params if they exist
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value)
    }
  })

  const response = await authorizedInstance.get(`/customer-feedback?${params}`)
  return response.data
}
